import { render, staticRenderFns } from "./RmpFinalStep.vue?vue&type=template&id=1f0dd896"
import script from "./RmpFinalStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpFinalStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports